import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.MentionsTableView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'mentions'
  name: 'mentions-table'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  chartClass: 'mentions-table'

  initialize: (@options = {}) ->
    @columns = ['Empresa', '#menciones en el periodo', '#menciones benchmark']

  render: ->
    @specific_settings ||= {}

    @$el.html(@template(self: this))
    @bindChartsReady(1)
    @_getTable().addClass('processing')
    query = @labelsQuery(@labelFilter(), @labelsStructure())
    accountDescription = @options.settings.accountLabel.description
    rowColorOption = @getTemplateOptions().rows

    @setBenchmarkSettings(query) # setting benchmark in config has no effect, it's always true
    $.post(@options.chartApi.singleDimension, _.extend({}, query, @getExtraQuery()), (response) =>
      tableData = { columns: @columns, data: [], types: ['string', 'string', 'number'], options: {} }
      if accountDescription
        tableData['options'] = { account_description: '<img src="' + window.image_path('netflix_logo.png') + '">', rows: rowColorOption }
      @chartReady(".#{@chartClass}")
      benchmarkData = response.benchmark_data?[0]?.data || []
      return unless response.series.length > 0
      for serie in response.series[0].data
        benchmarkCount = _.find(benchmarkData, (data) -> data.code == serie.code)?.y || 0
        if serie.y && benchmarkCount
          benchmarkCount = if benchmarkCount == 0 then 1 else benchmarkCount
          variancePercentage = Math.round(((serie.y-benchmarkCount)*100)/benchmarkCount)
          if variancePercentage > 0
            variancePercentage = ' (+' +variancePercentage+ '%⇧)'
          else
            if variancePercentage < 0
              variancePercentage = ' (' +variancePercentage+ '%⇩)'
            else
              variancePercentage = ' (0%)'
        if serie.y && !benchmarkCount
          variancePercentage = ' (100%)'
        name = serie.name
        if _hasImage(name)
          name = _getImage(name)

        tableData.data.push([name, String(_formatNumber(serie.y) + variancePercentage) || '0', benchmarkCount ])
        @_getTable().html(new Monitoring.Reports.Executive.TableView(response: tableData).render().el)
    )
    return this

  _getTable: ->
    @$el.find(".#{@chartClass}")

  _formatNumber = (n) ->
    n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  _getImage = (name) ->
    '<img src="' + window.image_path(name.toLowerCase()) + '_logo.png">'

  _hasImage = (name) ->
    name in ['Directv','Netflix','Cablevision','Telecentro','Supercanal']
